<div class="btn-toolbar" *transloco="let t; read: 'ime.common.properties'">
  <button type="button" class="btn btn-outline-primary btn-sm me-1" (click)="actionBarService.buttonClick$.next('DownloadExcel')">
    <svg viewBox="0 0 8 8" class="icon small" [inlineSVG]="'#table-cells'">
    </svg>
    {{t('Export')}}
  </button>
</div>
